import script from "./Datagrid.vue?vue&type=script&setup=true&lang=js"
export * from "./Datagrid.vue?vue&type=script&setup=true&lang=js"

import "./Datagrid.vue?vue&type=style&index=0&id=1cdae20a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdae20a"]])

export default __exports__